import { forwardRef } from 'react';
import MuiBadge, {
  type BadgeProps as MuiBadgeProps,
} from '@mui/material/Badge';

export interface BadgeProps extends MuiBadgeProps {}

const Badge = forwardRef<HTMLSpanElement, BadgeProps>(
  ({ color = 'orange-3', onClick, ...props }, ref) => {
    return (
      <MuiBadge
        slotProps={{ badge: { ref, onClick } }}
        color={color}
        {...props}
      />
    );
  }
);

export default Badge;
